// Fatia S4: botão "Pergunte ao Impulso" + painel lateral do assistente.
import { lazy, Suspense, useCallback, useState } from 'react'
import { Sparkles } from 'lucide-react'

const AssistantPanel = lazy(() => import('./AssistantPanel'))

export default function AssistantButton({ companyId }: { companyId: string }) {
  const [open, setOpen] = useState(false)
  const close = useCallback(() => setOpen(false), [])
  return (
    <>
      <button type="button" className="btn" onClick={() => setOpen(true)} aria-label="Pergunte ao Seu Impulso" aria-haspopup="dialog" aria-expanded={open}>
        <Sparkles size={16} color="var(--primary)" />
        <span className="hide-sm">Pergunte ao Seu Impulso</span>
      </button>
      {open && (
        <Suspense fallback={null}>
          <AssistantPanel companyId={companyId} onClose={close} />
        </Suspense>
      )}
    </>
  )
}
